import React from "react";
import AllUser from "../../components/user/table/component";

const Component = () => {
  return <AllUser tableHeading="All Customers" />;
};

export default Component;
